import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import ContentMath from "./ContentMath";
import ContentAsset from "./ContentAsset";
import LogoIcon from "@components/Global/Custom/Logo/LogoIcon";

const ContentSummary = ({ title, text }) => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();

	const summaryTitle = title;
	const options = {
		renderNode: {
			[INLINES.HYPERLINK]: (node, children) => {
				return (
					<a href={`${node.data.uri}`} target="_blank">
						{children}
					</a>
				);
			},
			[BLOCKS.EMBEDDED_ENTRY]: (node) => {
				const entry = store.findLinkedEntity(node, text?.links.entries);
				if (!entry) return;
				switch (entry.__typename) {
					case "Math":
						return <ContentMath {...entry} />;
				}
			},
			[INLINES.EMBEDDED_ENTRY]: (node) => {
				const entry = store.findLinkedEntity(node, text?.links.entries);
				if (!entry) return;
				switch (entry.__typename) {
					case "Math":
						return <ContentMath {...entry} />;
				}
			},
			[INLINES.ENTRY_HYPERLINK]: (node, children) => {
				const entry = store.findLinkedEntity(node, text?.links.entries);
				if (!entry) return;
				return (
					<a href={`${entry.folder}${entry.slug}`} target="_blank">
						{children}
					</a>
				);
			},
			[BLOCKS.EMBEDDED_ASSET]: (node) => {
				const asset = store.findLinkedEntity(node, text?.links.assets);
				if (!asset) return;
				return <ContentAsset {...asset} />;
			},
		},
	};

	text = documentToReactComponents(text?.json, options);

	return (
		<div className={classes.summaryBox}>
			<h3 className={classes.summaryTitle}>{summaryTitle}</h3>
			<div>{text}</div>
			<div className={classes.summaryLogo}>
				<LogoIcon width={30} />
			</div>
		</div>
	);
};

ContentSummary.propTypes = {};
export default ContentSummary;
